/**
 * Local, non-customerizable MetricPage constants (layout/paging).
 *
 * Customer/domain + product UI config lives in `tpoGenConfig.metricPageConfig`
 * (types in `config/metricPageConfig.ts`) and is consumed via
 * `useTpoGenConfig().metricPageConfig`.
 */

export const PAGE_LIMIT = 50;

export const PLAN_ACTION_MENU_KEYS = {
    deletePlan: 'delete_plan',
    deleteAllPromotions: 'delete_all_promotions',
} as const;
